import { getModelScreenerNumericCellValue } from "@pages/managed-accounts/model-screener/utils";
import React, { useMemo } from "react";
import { SHTypography } from "@components/design-systems";
import { ModelScreenerCellData } from "@models/model-screener/entities/modelScreenerData";
import { MSSmallSampleWarningIcon } from "../small-sample-warning-icon";

export const MSTablePercentageCell = React.memo(
  ({ cellData }: { cellData: ModelScreenerCellData }) => {
    const value = useMemo(() => {
      return getModelScreenerNumericCellValue({
        cellValue: cellData.value,
        suffix: "%",
      });
    }, [cellData]);

    return (
      <>
        <SHTypography variant={"body2"} fontSize={13} lineHeight={1.2}>
          {value}
        </SHTypography>
        {cellData.shouldShowCaution && <MSSmallSampleWarningIcon />}
      </>
    );
  },
);
